import React,{ useState } from 'react';
import '../assets/scss/main.scss';
import DashboardSideBar from '../Components/DashboardSideBar'
import { Dropdown } from 'react-bootstrap'  

function MeetingLayout(props) {  

    let toggleSideBar = () => {
        let bodyElement = document.getElementsByTagName("BODY")[0];
        bodyElement.classList.toggle("sidebar-open"); 
    }

    return (  
                <div className="wrapper"> 
                    <header className="main-header">

                        <a href="profile.html" className="logo">
                            <img src={ require('../assets/images/logo_final.png') }/>
                        </a>  
                    </header>

                    <DashboardSideBar/>
                    
                    <div className="content-wrapper" style={{ paddingTop: '0px'}}>  
                        <section>  

                            {props.children}  

                        </section>  
                    </div>
            </div>
      );
}
  
export default MeetingLayout;